/* tslint:disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { HttpService, CustomAxiosRequestConfig } from "@infrastructure/transport/httpservice";
import { AppConfig } from "@infrastructure/config/config";


export class FeatureFlagController {
        private disableErrorHandling: boolean = false;
        constructor(config?: CustomAxiosRequestConfig){
            this.disableErrorHandling = config && config.disableErrorHandling || false;
        }
    
        public getAllFeatureFlags = (): Promise<OperationResult<ProxyModel.FeatureFlagViewModel[],any>> => {
            const route = `api/FeatureFlag/`;
            return HttpService.Instance.request<ProxyModel.FeatureFlagViewModel[],any>({
                url: HttpService.Instance.GetUrl(route, 'FeatureFlagController','GetAllFeatureFlags'),
                method: "get",
                data: null,
                disableErrorHandling: this.disableErrorHandling,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });
        };
    
    
    
}